export default __webpack_public_path__ + "cc889a681b8002d26fffcd848f7d135a.png";